export default __webpack_public_path__ + "static/media/closet4-1440w.5cdc99a5.avif";